import api from '@/api';
import { menu } from '@/assets/js/manage';

const state = () => ({
  menuList:[], //已选择模块
  moduleList:[],//未选择模块
  reloadMenuList: false, //是否刷新模块
})

const getters = {

}

const mutations = {
  //更新已选择模块
  setMenuList(state, data) {
    state.menuList = data;
  },
  //是否刷新模块
  setReloadMenuList(state, data) {
    state.reloadMenuList = data;
  },
  //更新未选中模块
  setFilterModule(state, data) {
    state.moduleList = data;
  },

}

const actions = {
  //获取已选择模块
  getMenuList: async ({rootState, dispatch, state, commit }, cvDetail)=>{
    cvDetail = cvDetail || rootState.editor.cvDetail;

    let { submodule_info } = cvDetail;
    let { sections_position=[], custom_sections_titles={}, } = submodule_info;
    let menuList = [];
    sections_position.forEach(item=>{
      let obj = {
        id: item.id,
        info_ids: item.info_ids,
        title: '',
        type: item.type,
        key: item.type === 'custom' ? item.id : item.type,
        sections_position: item,
      }
      let constTitle = /works|edus|orgs|extras|opus/gim;
      if (constTitle.test(item.type)) {
        obj.title = submodule_info[String(item.type) + '_title'] || '未命名模块';
      } else {
        obj.title = custom_sections_titles[item.id + '_title'] || '未命名模块';
      }
      // 子模块数据start
      obj.info_ids = state[typeof obj.key ==='number' ? obj.id : obj.key] || [];
      if (item.type === 'extras') {
        // obj.others = state.others;
      }

      menuList.push(obj)
    })
    // 操作完经历库刷新字数
    // dispatch('editor/getCheckData',{},{ root: true })
    // 更新已选择模块
    commit('setMenuList', menuList)
    // console.log('menuList=>>',menuList)

    //触发未选择模块检索
    dispatch('getFilterModule');

  },
  //过滤未选中模块
  getFilterModule: async ({rootState, dispatch, state, commit })=>{
    let cvDetail = rootState.editor.cvDetail;
    // let newMenu = JSON.parse(JSON.stringify(menu));

    let checkMenu = state.menuList.map(item=> item.key);
    let newMenu = menu.filter(item=> !checkMenu.includes(item.type) );
    let res = await api.cvsV3.getCvTemplateInfo()
    let list = []
    if(res.code === 1000){
      list = res.data
    }
    if (!cvDetail.basic_info.school_logo_url){
      newMenu.unshift({
        type: 'school',
        from: '',
        name: '校徽',
        placeholder: '校徽可以凸显名校背景',
        iconfont: 'iconxiaohui',
        hasVip: true
      })
    }
    newMenu.forEach(item=>{
      let newObj = list.find(k => k.type === item.type)
      if(newObj){
        item.id = newObj.id
      }
    })
    // 设置渲染
    commit('setFilterModule',newMenu)
  }

}


export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state
}
